// extracted by mini-css-extract-plugin
export default {"fieldTextInput":"VoucherForm_fieldTextInput__cz7yO","voucherTitleBox":"VoucherForm_voucherTitleBox__17r-G"};